export class SharepointListItemsRequestModel {
    SiteId: string
    DocumentLibraryName: string
    CanIncludeFile: boolean
    EngagementServiceLines: string
}